import { calculateFileSize } from 'Utils/calculateFileSize'
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import React, { useId } from 'react'
import DragAndDropUpload from 'Components/DragAndDropUpload/DragAndDropUpload'
import { Tooltip } from 'react-tooltip'
import Dropdown from 'Common/DropDown/Dropdown'
import ThreeDotsIcon from 'SVGS/ThreeDotsIcon'


const CustomFileAttachment = ({ onFileChange, disabled, name, data, onDeleteFile, multiple, openViewAttachment, extraClass }) => {
    const componentId = useId()
    return (
        <div>
            <Tooltip id="CustomFileAttachment-tooltip" />
            <DragAndDropUpload
                id={componentId}
                name={name}
                onFilesSelected={onFileChange}
                disabled={disabled}
                multiple={multiple}
            />
            <div className="grid grid-cols-12 gap-2 mt-4">
                {data?.map((item, itemIndex) => {
                    return (
                        <div className={`${extraClass ? extraClass : 'col-span-4'}`}>
                            <div className="flex w-full rounded-md bg-primaryLightColor">
                                <div className="p-4 m-2 bg-white rounded-md text-primary">
                                    {/* <FaRegFileAlt size={16} /> */}
                                    <img src="/img/file.svg" alt="cross" />

                                </div>
                                <div className="flex flex-col">
                                    <span
                                        data-tooltip-id="CustomFileAttachment-tooltip"
                                        data-tooltip-content={item.fileName} className="pt-2 text-sm font-semibold truncate max-w-[50px]"> {item.fileName}</span>
                                    <span className="text-sm text-secondaryLight">{calculateFileSize(item.fileBase64)}</span>
                                </div>

                                {(onDeleteFile || openViewAttachment) && <div className="p-4 mt-2 ml-auto rounded-md text-primary" >
                                    <Dropdown>
    <Dropdown.Button>
        <ThreeDotsIcon />
    </Dropdown.Button>

    <Dropdown.Menu>
        {onDeleteFile && (
            <Dropdown.MenuItem
                className="group rdx_item"
                onClick={() => onDeleteFile(item, itemIndex)}
            >
                Delete
            </Dropdown.MenuItem>
        )}

        {openViewAttachment && (
            <Dropdown.MenuItem
                className="group rdx_item"
                onClick={() => openViewAttachment(item, itemIndex)}
            >
                View Attachment
            </Dropdown.MenuItem>
        )}
    </Dropdown.Menu>
</Dropdown>
                                </div>}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default withFeatureSafe(CustomFileAttachment);